<template>
  <footer class="store-footer" v-if="settings">
    <div class="store-footer-inner container w-full p-8 mx-auto">
    <div class="grid md:gap-5 md:grid-cols-4">
      <!-- <div class="w-80">
        <h1 class="text-2xl font-bold tracking-wide text-gray-700">
          Have any questions?
        </h1>
        <p class="my-4 text-sm font-light text-gray-500">
          Lorem Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Reprehenderit suscipit voluptate facere.
        </p>
        <button
          class="h-12 px-4 py-2 font-light text-white bg-blue-800 rounded-md w-44"
        >
          Get in touch
        </button>
      </div> -->
      <div class="flex flex-col mt-3 md:items-center md:w-52 md:mt-0">
        <div class="flex flex-col">
          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">{{ $t('footer.header1') }}</h1>
          <a
            class="mb-3 text-sm font-light text-gray-500"
            target="__blank"
            :href="`${this.$store.state.baseUrl}pages/contact`"
            >{{ $t('footer.sub1') }}</a
          >
          <a
            class="mb-3 text-sm font-light text-gray-500"
            target="__blank"
            :href="`${this.$store.state.baseUrl}privacy/policy`"
            >{{ $t('footer.sub2') }}</a
          >
          <a
            class="mb-3 text-sm font-light text-gray-500"
            target="__blank"
            :href="`${this.$store.state.baseUrl}pages/terms`"
            >{{ $t('footer.sub3') }}</a
          >
          <a
            class="mb-3 text-sm font-light text-gray-500"
            target="__blank"
            :href="`${this.$store.state.baseUrl}cms/refund-policy`"
            >{{ $t('footer.refund-policy') }}</a
          >
        </div>
      </div>
      <div class="flex flex-col mt-3 md:mt-0 md:items-center md:w-52">
        <div class="flex flex-col">
          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">
            {{ $t('footer.header2') }}
          </h1>
          <a
            class="mb-3 text-sm font-light text-gray-500"
            target="__blank"
            :href="`${this.$store.state.baseUrl}register/driver`"
            >{{ $t('footer.sub4') }}</a
          >
          <a
            class="mb-6 text-sm font-light text-gray-500"
            target="__blank"
            :href="`${this.$store.state.baseUrl}register/vendor`"
            >{{ $t('footer.sub5') }} {{ settings.strings.app_name }}?</a
          >
        </div>
      </div>
      <div class="flex flex-col mt-3 md:mt-0 md:items-center md:w-52">
        <div class="flex flex-col">
          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">{{ $t('footer.header3') }}</h1>
          <a href="" class="mb-3 text-sm font-light text-gray-500"
            >{{ $t('footer.sub6') }}</a
          >
          <a href="" class="mb-3 text-sm font-light text-gray-500">{{ $t('footer.sub7') }}</a>
        </div>
      </div>
      <div class="flex flex-col mt-3 md:mt-0 md:items-center md:w-52">
        <div class="flex flex-col">
          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">{{ $t('footer.header5') }}</h1>
          <a
            class="mb-3 text-sm font-light text-gray-500"
            v-for="vendor in vendors"
            :key="vendor.id"
          >
            <a
              class="text-gray-500"
              :href="
                $router.resolve({
                  params: {
                    id: vendor.id,
                    slug: sanitizeTitle(`${vendor.slug}`),
                  },
                }).href
              "
              >{{ vendor.name }}</a
            >
          </a>
        </div>
      </div>
    </div>
    <p class="mt-10 text-sm font-light text-gray-500">
      {{ settings.strings.website.websiteFooterBrief }}
    </p>
    <div class="footer-social-links">
      <a
        class="footer-social-link"
        aria-label="Facebook"
        :href="
          settings.strings.website.social
            ? settings.strings.website.social.fbLink
            : '#'
        "
      ><ChatBubbleLeftEllipsisIcon aria-hidden="true" /></a>
      <a
        class="footer-social-link"
        aria-label="Instagram"
        :href="
          settings.strings.website.social
            ? settings.strings.website.social.igLink
            : '#'
        "
      ><CameraIcon aria-hidden="true" /></a>
      <a
        class="footer-social-link"
        aria-label="Twitter"
        :href="
          settings.strings.website.social
            ? settings.strings.website.social.twLink
            : '#'
        "
      ><ChatBubbleLeftRightIcon aria-hidden="true" /></a>
    </div>
    <div class="footer-signature">
      <p class="footer-wordmark">
        <span>Take your business</span>
        <span class="footer-wordmark-accent">online</span>
      </p>
    </div>
    </div>
  </footer>
</template>
<script>
import axios from "axios";
import {
  CameraIcon,
  ChatBubbleLeftEllipsisIcon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/vue/24/outline";
export default {
  name: "FooterView",
  components: {
    CameraIcon,
    ChatBubbleLeftEllipsisIcon,
    ChatBubbleLeftRightIcon,
  },
  data() {
    return {
      settings: null,
      vendors: null,
      base_url: this.$store.state.baseUrl,
    };
  },

  mounted() {
    this.$store.dispatch("fetchSettings", this.items).then(() => {
      this.settings = this.$store.state.settings;
    });
    let selectedLanguage = localStorage.getItem("selectedLanguage");
    const headers = {
      lang: selectedLanguage,
    };
    axios
      .get(this.base_url + "api/vendor/types", {headers})
      .then((response) => {
        let vendorTypes = response.data;
        this.vendors = vendorTypes.slice(0, 4);
      })
      .catch((error) => console.log(error));
  },

  methods: {
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>

<style scoped>
.store-footer {
  margin-top: 2rem;
  color: #e9f0e9;
  background: #203a30;
}

.store-footer-inner {
  max-width: 80rem;
  padding: 3.25rem 1.5rem 2rem;
}

.store-footer h1 {
  color: #b8d5c0;
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 800;
}

.store-footer a,
.store-footer p {
  color: #c8d5cc;
}

.store-footer a {
  transition: color 150ms ease;
}

.store-footer a:hover {
  color: #fff;
}

.store-footer > div > p {
  max-width: 48rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(233, 240, 233, 0.16);
  line-height: 1.7;
}

.footer-signature {
  margin-top: 2.25rem;
  padding-top: 1.1rem;
  border-top: 1px solid rgba(233, 240, 233, 0.16);
}

.footer-wordmark {
  display: flex;
  flex-direction: column;
  margin: 0;
  color: #f4f7ef !important;
  font-family: var(--font-body);
  font-size: 4.5rem;
  font-weight: 600;
  line-height: 0.98;
}

.footer-wordmark-accent {
  color: #b8d5c0;
}

.footer-social-links {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 1rem;
}

.footer-social-link {
  display: grid;
  width: 2.5rem;
  height: 2.5rem;
  place-items: center;
  border: 1px solid rgba(184, 213, 192, 0.45);
  border-radius: 50%;
  color: #b8d5c0 !important;
  transition: color 150ms ease, border-color 150ms ease, background 150ms ease;
}

.footer-social-link:hover {
  border-color: #b8d5c0;
  color: #fff !important;
  background: rgba(184, 213, 192, 0.12);
}

.footer-social-link svg {
  width: 1.15rem;
  height: 1.15rem;
  stroke-width: 1.7;
}

@media (max-width: 767px) {
  .store-footer-inner {
    padding: 2.5rem 1.25rem 1.5rem;
  }

  .store-footer .grid {
    gap: 1.5rem;
  }

  .footer-wordmark {
    font-size: 2rem;
  }
}
</style>
